import { render, staticRenderFns } from "./sosPosition.vue?vue&type=template&id=4ac5ec6b&scoped=true&"
import script from "./sosPosition.vue?vue&type=script&lang=js&"
export * from "./sosPosition.vue?vue&type=script&lang=js&"
import style0 from "./sosPosition.vue?vue&type=style&index=0&id=4ac5ec6b&prod&lang=css&"
import style1 from "./sosPosition.vue?vue&type=style&index=1&id=4ac5ec6b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac5ec6b",
  null
  
)

export default component.exports